import React, { useState, useEffect } from 'react';
import { Icons, getAppIcon } from '../components/ui/Icons.tsx';
import { ConnectedApp, UsageStats, ApprovalMode } from '../types';
import { api } from '../services/api';
import { CustomSelect } from '../components/ui/CustomSelect.tsx';

// Custom Icons for Dropdowns
const SunIcon = (props: any) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <circle cx="12" cy="12" r="4"></circle>
    <path d="M12 2v2M12 20v2M4.93 4.93l1.41 1.41M17.66 17.66l1.41 1.41M2 12h2M20 12h2M6.34 17.66l-1.41 1.41M19.07 4.93l-1.41 1.41"></path>
  </svg>
);

const MoonIcon = (props: any) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <path d="M12 3a6 6 0 0 0 9 9 9 9 0 1 1-9-9Z"></path>
  </svg>
);

const MonitorIcon = (props: any) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <rect x="2" y="3" width="20" height="14" rx="2" ry="2"></rect>
    <line x1="8" y1="21" x2="16" y2="21"></line>
    <line x1="12" y1="17" x2="12" y2="21"></line>
  </svg>
);

const BrainIcon = (props: any) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <path d="M9.5 2A2.5 2.5 0 0 1 12 4.5v15a2.5 2.5 0 0 1-4.96-.44 2.5 2.5 0 0 1 0-3.12 3 3 0 0 1 0-4.88 2.5 2.5 0 0 1 0-3.12A2.5 2.5 0 0 1 9.5 2Z"></path>
    <path d="M14.5 2A2.5 2.5 0 0 0 12 4.5v15a2.5 2.5 0 0 0 4.96-.44 2.5 2.5 0 0 0 0-3.12 3 3 0 0 0 0-4.88 2.5 2.5 0 0 0 0-3.12A2.5 2.5 0 0 0 14.5 2Z"></path>
  </svg>
);

const SparklesIcon = (props: any) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <path d="m12 3-1.912 5.813a2 2 0 0 1-1.275 1.275L3 12l5.813 1.912a2 2 0 0 1 1.275 1.275L12 21l1.912-5.813a2 2 0 0 1 1.275-1.275L21 12l-5.813-1.912a2 2 0 0 1-1.275-1.275L12 3Z"></path>
    <path d="m5 3 1 2.5L8.5 6 6 7 5 9.5 4 7 1.5 6 4 5 5 3Z"></path>
  </svg>
);

const RobotIcon = (props: any) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <rect x="3" y="11" width="18" height="10" rx="2"></rect>
    <circle cx="12" cy="5" r="2"></circle>
    <path d="M12 7v4"></path>
    <line x1="8" y1="16" x2="8.01" y2="16"></line>
    <line x1="16" y1="16" x2="16.01" y2="16"></line>
  </svg>
);

const CodeIcon = (props: any) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <polyline points="16 18 22 12 16 6"></polyline>
    <polyline points="8 6 2 12 8 18"></polyline>
  </svg>
);

const PaletteIcon = (props: any) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12c0 5.5228 4.47715 10 10 10z"></path>
    <path d="M12 6A1.5 1.5 0 1 1 12 3a1.5 1.5 0 0 1 0 3zm4.5 4a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm-9 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zM12 15a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3z"></path>
  </svg>
);

const BriefcaseIcon = (props: any) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <rect x="2" y="7" width="20" height="14" rx="2" ry="2"></rect>
    <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"></path>
  </svg>
);

const GraduationCapIcon = (props: any) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <path d="M22 10v6M2 10l10-5 10 5-10 5z"></path>
    <path d="M6 12v5c0 2 2 3 6 3s6-1 6-3v-5"></path>
  </svg>
);

const BuildingIcon = (props: any) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <rect x="4" y="2" width="16" height="20" rx="2" ry="2"></rect>
    <line x1="9" y1="22" x2="9" y2="16"></line>
    <line x1="15" y1="22" x2="15" y2="16"></line>
    <line x1="9" y1="16" x2="15" y2="16"></line>
    <path d="M8 6h2v2H8V6zm4 0h2v2H8V6zm4 0h2v2h-2V6zm-8 4h2v2H8v-2zm4 0h2v2h-2v-2zm4 0h2v2h-2v-2zm-8 4h2v2H8v-2zm4 0h2v2h-2v-2z"></path>
  </svg>
);


interface SettingsPageProps {
  onClose: () => void;
  onManageIntegrations: () => void;
  onPricingClick?: () => void;
  userName: string;
  onUpdateName: (name: string) => void;
  onUpdatePlan?: (plan: string) => void;
  connectedApps: ConnectedApp[];
  avatar?: string;
}

const ToggleSwitch: React.FC<{ checked: boolean; onChange: (val: boolean) => void }> = ({ checked, onChange }) => (
  <button 
    onClick={() => onChange(!checked)}
    className={`relative inline-flex h-6 w-11 shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none ${checked ? 'bg-black dark:bg-white' : 'bg-gray-200 dark:bg-gray-700'}`}
  >
    <span className={`pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white dark:bg-[#050505] shadow ring-0 transition duration-200 ease-in-out ${checked ? 'translate-x-5' : 'translate-x-0'}`} />
  </button>
);

const selectClassName = "w-full md:w-64 bg-white border border-gray-200 rounded-xl px-4 py-2.5 text-sm text-gray-800 outline-none focus:border-gray-400 transition-all cursor-pointer appearance-none bg-[url('data:image/svg+xml;charset=UTF-8,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2224%22%20height%3D%2224%22%20viewBox%3D%220%200%2024%2024%22%20fill%3D%22none%22%20stroke%3D%22%236b7280%22%20stroke-width%3D%222%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%3E%3Cpolyline%20points%3D%226%209%2012%2015%2018%209%22%3E%3C%2Fpolyline%3E%3C%2Fsvg%3E')] bg-[length:1.25rem] bg-[right_0.75rem_center] bg-no-repeat pr-10 shadow-sm hover:border-gray-300";

const getInitials = (name: string) => {
  if (!name) return "G";
  const parts = name.trim().split(/\s+/);
  if (parts.length >= 2) {
    return (parts[0][0] + parts[1][0]).toUpperCase();
  }
  return parts[0].substring(0, 2).toUpperCase();
};

const SettingsPage: React.FC<SettingsPageProps> = ({ 
  onClose, 
  onManageIntegrations, 
  onPricingClick, 
  userName, 
  onUpdateName, 
  onUpdatePlan, 
  connectedApps,
  avatar
}) => {
  const [email, setEmail] = useState("guest@neura.ai");
  const [activePlan, setActivePlan] = useState("free");
  const [billingCycle, setBillingCycle] = useState<string | null>(null);
  const [expiresAt, setExpiresAt] = useState<string | null>(null);
  const [notification, setNotification] = useState<string | null>(null);
  const [isEditingName, setIsEditingName] = useState(false);
  const [tempName, setTempName] = useState(userName);
  const [nameError, setNameError] = useState<string | null>(null);
  
  // Navigation State
  const [activeTab, setActiveTab] = useState<'general' | 'profile' | 'security' | 'approvals' | 'notifications' | 'subscription'>('general');

  const [usageStats, setUsageStats] = useState<UsageStats>({
      requests: 0,
      maxRequests: 100
  });

  // Load state values from localStorage or default values
  const [autoPromptSuggestion, setAutoPromptSuggestion] = useState(() => localStorage.getItem('setting_auto_prompt') !== 'false');
  const [language, setLanguage] = useState(() => localStorage.getItem('setting_language') || 'auto');
  const [themeMode, setThemeMode] = useState(() => localStorage.getItem('setting_theme') || 'Light');
  const [defaultModel, setDefaultModel] = useState(() => localStorage.getItem('setting_default_model') || 'gemini-flash');
  const [approvalMode, setApprovalMode] = useState<ApprovalMode>(() => (localStorage.getItem('setting_approval_mode') as ApprovalMode) || 'smart');

  const [bio, setBio] = useState(() => localStorage.getItem('setting_bio') || 'AI Enthusiast & Builder');
  const [role, setRole] = useState(() => localStorage.getItem('setting_role') || 'Developer');
  const [company, setCompany] = useState(() => localStorage.getItem('setting_company') || 'Personal');

  const [emailDaily, setEmailDaily] = useState(() => localStorage.getItem('setting_email_daily') !== 'false');
  const [emailWeekly, setEmailWeekly] = useState(() => localStorage.getItem('setting_email_weekly') === 'true');
  const [alertCompletion, setAlertCompletion] = useState(() => localStorage.getItem('setting_alert_completion') !== 'false');
  const [alertErrors, setAlertErrors] = useState(() => localStorage.getItem('setting_alert_errors') !== 'false');
  const [desktopBanner, setDesktopBanner] = useState(() => localStorage.getItem('setting_desktop_banner') === 'true');

  useEffect(() => {
    const loadUsage = async () => {
        try {
            const stats = await api.getUsage();
            setUsageStats(stats);
            const user = await api.getUser();
            setEmail(user.email);
            if (user.plan) setActivePlan(user.plan.toLowerCase());
            if (user.billing_cycle) setBillingCycle(user.billing_cycle);
            if (user.expires_at) setExpiresAt(user.expires_at);
            if (user.approval_mode) {
              setApprovalMode(user.approval_mode);
              localStorage.setItem('setting_approval_mode', user.approval_mode);
            }
        } catch (e) {
            console.error(e);
        }
    };
    loadUsage();
  }, []);

  useEffect(() => {
    setTempName(userName);
  }, [userName]);

  const showNotification = (msg: string) => {
    setNotification(msg);
    setTimeout(() => setNotification(null), 3000);
  };

  const handleSignOut = () => {
      api.signOut();
  };

  const handleManageBilling = () => {
    if (onPricingClick) {
        onPricingClick();
    }
  };

  const handleInvoices = () => {
    showNotification("Downloading latest invoice...");
  };

  const activeApps = connectedApps.filter(app => app.status === 'connected');

  const languageOptions = [
    { value: "auto", label: "Auto detect", icon: Icons.Globe, description: "System default language" },
    { value: "English", label: "English", icon: "🇺🇸", description: "English (US)" },
    { value: "Spanish", label: "Spanish", icon: "🇪🇸", description: "Español" },
    { value: "French", label: "French", icon: "🇫🇷", description: "Français" },
    { value: "German", label: "German", icon: "🇩🇪", description: "Deutsch" },
    { value: "Japanese", label: "Japanese", icon: "🇯🇵", description: "日本語" },
  ];

  const themeOptions = [
    { value: "Light", label: "Light", icon: SunIcon, description: "Clean and bright look" },
    { value: "Dark", label: "Dark", icon: MoonIcon, description: "Easy on the eyes" },
    { value: "System", label: "System", icon: MonitorIcon, description: "Match device settings" },
  ];

  const modelOptions = [
    { value: "gemini-flash", label: "Gemini 1.5 Flash (Default)", icon: Icons.Lightning, description: "Fast, efficient for everyday tasks" },
    { value: "gemini-pro", label: "Gemini 1.5 Pro", icon: BrainIcon, description: "High intelligence for complex reasoning" },
    { value: "claude-sonnet", label: "Claude 3.5 Sonnet", icon: SparklesIcon, description: "Excellent writing and coding skills" },
    { value: "gpt-4o", label: "GPT-4o", icon: RobotIcon, description: "Versatile, high-speed powerhouse" },
  ];

  const roleOptions = [
    { value: "Developer", label: "Developer", icon: CodeIcon, description: "Software engineer or builder" },
    { value: "Designer", label: "Designer", icon: PaletteIcon, description: "UI/UX or graphic designer" },
    { value: "Product Manager", label: "Product Manager", icon: BriefcaseIcon, description: "Product lead or coordinator" },
    { value: "Student", label: "Student", icon: GraduationCapIcon, description: "Enrolled in school or university" },
    { value: "Business Owner", label: "Business Owner", icon: BuildingIcon, description: "Founder, executive or manager" },
    { value: "Other", label: "Other", icon: Icons.User, description: "Other profession" },
  ];

  const renderTabContent = () => {
    switch(activeTab) {
      case 'general':
        return (
          <div className="space-y-6 animate-in fade-in duration-300">
            {/* Account Information Card */}
            <div className="bg-white dark:bg-[#212121] border border-gray-100 dark:border-gray-800 rounded-2xl p-6 shadow-sm hover:border-gray-200 dark:hover:border-gray-700 transition-all">
                <h4 className="text-xs font-semibold text-gray-400 dark:text-gray-500 uppercase tracking-wider mb-4">Account Information</h4>
                <div className="space-y-4">
                    {/* Username */}
                    <div className="flex flex-col md:flex-row md:items-center justify-between gap-4 py-3 border-b border-gray-50 dark:border-gray-800">
                        <div>
                            <span className="block text-sm font-medium text-black dark:text-white">Username</span>
                            <span className="text-xs text-gray-500 dark:text-gray-400">Your profile display name.</span>
                        </div>
                        <div className="w-full md:w-64">
                            {isEditingName ? (
                                <div className="space-y-1">
                                    <div className="relative flex items-center">
                                        <input 
                                            type="text" 
                                            autoFocus
                                            value={tempName} 
                                            onChange={(e) => {
                                                const val = e.target.value;
                                                setTempName(val);
                                                if (val.length < 4) setNameError("Name must be at least 4 characters");
                                                else if (val.length > 20) setNameError("Name cannot exceed 20 characters");
                                                else setNameError(null);
                                            }}
                                            onKeyDown={(e) => {
                                                if (e.key === 'Enter' && !nameError && tempName.length >= 4 && tempName.length <= 20) {
                                                    onUpdateName(tempName);
                                                    setIsEditingName(false);
                                                    showNotification("Username updated!");
                                                } else if (e.key === 'Escape') {
                                                    setTempName(userName);
                                                    setIsEditingName(false);
                                                    setNameError(null);
                                                }
                                            }}
                                            className={`w-full bg-white dark:bg-[#050505] border ${nameError ? 'border-red-500 ring-red-50' : 'border-gray-200 dark:border-gray-800 ring-black/5'} rounded-xl px-4 py-2 text-sm text-black dark:text-white focus:ring-2 outline-none transition-all pr-10`} 
                                        />
                                        <button 
                                            onClick={() => {
                                                if (!nameError && tempName.length >= 4 && tempName.length <= 20) {
                                                    onUpdateName(tempName);
                                                    setIsEditingName(false);
                                                    showNotification("Username updated!");
                                                }
                                            }}
                                            disabled={!!nameError || tempName.length < 4 || tempName.length > 20}
                                            className="absolute right-3 p-1 text-black dark:text-white hover:text-indigo-600 disabled:text-gray-300 dark:disabled:text-gray-600"
                                        >
                                            <Icons.Check className="w-4 h-4" />
                                        </button>
                                    </div>
                                    {nameError && <p className="text-[10px] text-red-500 font-medium">{nameError}</p>}
                                </div>
                            ) : (
                                <div 
                                    onClick={() => setIsEditingName(true)}
                                    className="flex items-center justify-between w-full bg-gray-50/50 dark:bg-[#050505] border border-gray-200 dark:border-gray-800 rounded-xl px-4 py-2 text-sm text-black dark:text-white hover:border-gray-300 dark:hover:border-gray-700 cursor-pointer group transition-all"
                                >
                                    <span className="truncate">{userName}</span>
                                    <Icons.Pencil className="w-4 h-4 text-black dark:text-white opacity-40 group-hover:opacity-100 transition-opacity" />
                                </div>
                            )}
                        </div>
                    </div>

                    {/* Email */}
                    <div className="flex flex-col md:flex-row md:items-center justify-between gap-4 py-3">
                        <div>
                            <span className="block text-sm font-medium text-black dark:text-white">Email Address</span>
                            <span className="text-xs text-gray-500 dark:text-gray-400">Your account sign-in email.</span>
                        </div>
                        <div className="w-full md:w-64 bg-gray-50 dark:bg-[#050505] border border-gray-200 dark:border-gray-800 rounded-xl px-4 py-2.5 text-sm text-gray-500 dark:text-gray-400 select-all">
                            {email}
                        </div>
                    </div>
                </div>
            </div>

            {/* Application Settings Card */}
            <div className="bg-white dark:bg-[#212121] border border-gray-100 dark:border-gray-800 rounded-2xl p-6 shadow-sm hover:border-gray-200 dark:hover:border-gray-700 transition-all">
                <h4 className="text-xs font-semibold text-gray-400 dark:text-gray-500 uppercase tracking-wider mb-4">Application Settings</h4>
                <div className="space-y-4">
                    {/* Auto Prompt */}
                    <div className="flex items-center justify-between py-3">
                        <div className="pr-4">
                            <span className="block text-sm font-medium text-black dark:text-white">Enable auto-prompt idea suggestion</span>
                            <span className="text-xs text-gray-500 dark:text-gray-400">Generate creative prompt ideas automatically on input.</span>
                        </div>
                        <ToggleSwitch 
                            checked={autoPromptSuggestion} 
                            onChange={(val) => {
                                setAutoPromptSuggestion(val);
                                localStorage.setItem('setting_auto_prompt', String(val));
                                showNotification(val ? "Auto-prompt suggestions enabled" : "Auto-prompt suggestions disabled");
                            }} 
                        />
                    </div>
                </div>
            </div>

            {/* Preferences Card */}
            <div className="bg-white dark:bg-[#212121] border border-gray-100 dark:border-gray-800 rounded-2xl p-6 shadow-sm hover:border-gray-200 dark:hover:border-gray-700 transition-all">
                <h4 className="text-xs font-semibold text-gray-400 dark:text-gray-500 uppercase tracking-wider mb-4">Preferences</h4>
                <div className="space-y-4">
                    {/* Language Select */}
                    <div className="flex flex-col md:flex-row md:items-center justify-between gap-4 py-3 border-b border-gray-50 dark:border-gray-800">
                        <div>
                            <span className="block text-sm font-medium text-black dark:text-white">Language</span>
                            <span className="text-xs text-gray-500 dark:text-gray-400">Your preferred interface language.</span>
                        </div>
                        <CustomSelect 
                            value={language}
                            options={languageOptions}
                            onChange={(val) => {
                                setLanguage(val);
                                localStorage.setItem('setting_language', val);
                                showNotification(`Language set to ${val === 'auto' ? 'Auto detect' : val}`);
                            }}
                            className="w-full md:w-64"
                        />
                    </div>

                    {/* Theme Select */}
                    <div className="flex flex-col md:flex-row md:items-center justify-between gap-4 py-3 border-b border-gray-50 dark:border-gray-800">
                        <div>
                            <span className="block text-sm font-medium text-black dark:text-white">Theme Mode</span>
                            <span className="text-xs text-gray-500 dark:text-gray-400">Switch between light, dark, and system themes.</span>
                        </div>
                        <CustomSelect 
                            value={themeMode}
                            options={themeOptions}
                            onChange={(val) => {
                                setThemeMode(val);
                                localStorage.setItem('setting_theme', val);
                                showNotification(`Theme set to ${val}`);
                                window.dispatchEvent(new Event('neura-theme-change'));
                            }}
                            className="w-full md:w-64"
                        />
                    </div>

                    {/* Default AI Model */}
                    <div className="flex flex-col md:flex-row md:items-center justify-between gap-4 py-3">
                        <div>
                            <span className="block text-sm font-medium text-black dark:text-white">Default AI Model</span>
                            <span className="text-xs text-gray-500 dark:text-gray-400">Primary model for chat completions.</span>
                        </div>
                        <CustomSelect 
                            value={defaultModel}
                            options={modelOptions}
                            onChange={(val) => {
                                setDefaultModel(val);
                                localStorage.setItem('setting_default_model', val);
                                showNotification(`Default model set to ${val}`);
                            }}
                            className="w-full md:w-64"
                        />
                    </div>
                </div>
            </div>
          </div>
        );
      case 'profile':
        return (
          <div className="space-y-6 animate-in fade-in duration-300">
            {/* Google Synced Avatar Card */}
            <div className="bg-white dark:bg-[#212121] border border-gray-100 dark:border-gray-800 rounded-2xl p-6 shadow-sm hover:border-gray-200 dark:hover:border-gray-700 transition-all flex flex-col sm:flex-row gap-6 items-center">
                <div className="w-20 h-20 rounded-full overflow-hidden flex-shrink-0 border border-gray-200 dark:border-gray-700 flex items-center justify-center relative bg-rose-500 text-white font-medium text-xl shadow-inner">
                    {avatar ? (
                        <img src={avatar} className="w-full h-full object-cover" alt="Profile" />
                    ) : (
                        getInitials(userName)
                    )}
                </div>

                <div className="flex-1 flex flex-col gap-1 items-start text-center sm:text-left">
                    <h4 className="text-sm font-semibold text-black dark:text-white">Google Profile Picture</h4>
                    <p className="text-xs text-gray-500 dark:text-gray-400">Your profile picture is automatically synced from your connected Google Account profile.</p>
                </div>
            </div>

            {/* Profile details form card */}
            <div className="bg-white dark:bg-[#212121] border border-gray-100 dark:border-gray-800 rounded-2xl p-6 shadow-sm hover:border-gray-200 dark:hover:border-gray-700 transition-all space-y-4">
                {/* Bio */}
                <div className="flex flex-col gap-2">
                    <label className="text-sm font-medium text-black dark:text-white">Biography</label>
                    <textarea 
                        value={bio}
                        onChange={(e) => {
                            const val = e.target.value;
                            setBio(val);
                            localStorage.setItem('setting_bio', val);
                        }}
                        rows={3}
                        placeholder="Tell us about yourself..."
                        className="w-full bg-white dark:bg-[#050505] border border-gray-200 dark:border-gray-800 rounded-xl px-4 py-2.5 text-sm text-black dark:text-white outline-none focus:border-black dark:focus:border-white transition-all resize-none shadow-sm"
                    />
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    {/* Role selection */}
                    <div className="flex flex-col gap-2">
                        <label className="text-sm font-medium text-black dark:text-white">Job Title / Role</label>
                        <CustomSelect 
                            value={role}
                            options={roleOptions}
                            onChange={(val) => {
                                setRole(val);
                                localStorage.setItem('setting_role', val);
                                showNotification(`Role updated to ${val}`);
                            }}
                            className="w-full"
                        />
                    </div>

                    {/* Company Name */}
                    <div className="flex flex-col gap-2">
                        <label className="text-sm font-medium text-black dark:text-white">Company / Workspace</label>
                        <input 
                            type="text"
                            value={company}
                            onChange={(e) => {
                                const val = e.target.value;
                                setCompany(val);
                                localStorage.setItem('setting_company', val);
                            }}
                            placeholder="Company name"
                            className="w-full bg-white dark:bg-[#050505] border border-gray-200 dark:border-gray-800 rounded-xl px-4 py-2.5 text-sm text-black dark:text-white outline-none focus:border-black dark:focus:border-white transition-all shadow-sm"
                        />
                    </div>
                </div>
            </div>
          </div>
        );
      case 'security':
        return (
          <div className="space-y-6 animate-in fade-in duration-300">
            <div className="bg-white dark:bg-[#212121] border border-gray-100 dark:border-gray-800 rounded-2xl p-6 shadow-sm hover:border-gray-200 dark:hover:border-gray-700 transition-all">
                <h4 className="text-xs font-semibold text-gray-400 dark:text-gray-500 uppercase tracking-wider mb-4">Active Sessions</h4>
                <div className="space-y-3">
                    {[
                        { device: 'Windows PC • Chrome', location: 'Bengaluru, India', time: 'Active Now', current: true },
                        { device: 'iPhone 15 • Mobile Safari', location: 'Bengaluru, India', time: '2 hours ago', current: false },
                        { device: 'MacBook Pro • Safari', location: 'Chennai, India', time: 'Yesterday', current: false }
                    ].map((sess, idx) => (
                        <div key={idx} className="flex justify-between items-center bg-white dark:bg-[#050505] border border-gray-50 dark:border-gray-800 rounded-xl p-3.5 hover:border-gray-200 dark:hover:border-gray-750 transition-colors">
                            <div className="flex items-center gap-3">
                                <div className="p-2 bg-gray-50 dark:bg-gray-800 rounded-lg border border-gray-100 dark:border-gray-700 text-gray-400 dark:text-gray-500">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                        <rect x="2" y="3" width="20" height="14" rx="2" ry="2"></rect>
                                        <line x1="8" y1="21" x2="16" y2="21"></line>
                                        <line x1="12" y1="17" x2="12" y2="21"></line>
                                    </svg>
                                </div>
                                <div>
                                    <span className="text-xs font-semibold text-black dark:text-white flex items-center gap-1.5">
                                        {sess.device}
                                        {sess.current && <span className="bg-green-100 dark:bg-green-900/30 text-green-700 dark:text-green-450 text-[9px] font-semibold px-1.5 py-0.5 rounded-full uppercase animate-pulse">Current</span>}
                                    </span>
                                    <span className="block text-[11px] text-gray-500 dark:text-gray-400">{sess.location} • {sess.time}</span>
                                </div>
                            </div>
                            {!sess.current && (
                                <button 
                                    onClick={() => showNotification("Terminated session successfully.")}
                                    className="text-xs font-semibold text-gray-400 dark:text-gray-500 hover:text-red-500 dark:hover:text-red-400 transition-colors"
                                >
                                    Revoke
                                </button>
                            )}
                        </div>
                    ))}
                    
                    <button 
                        onClick={() => showNotification("Logged out of all other sessions.")}
                        className="w-full py-2.5 border border-dashed border-gray-200 dark:border-gray-800 hover:border-black dark:hover:border-white rounded-xl text-xs font-semibold text-black dark:text-white hover:bg-gray-50 dark:hover:bg-gray-800 transition-all bg-white dark:bg-[#050505]"
                    >
                        Log Out of All Other Sessions
                    </button>
                </div>
            </div>
          </div>
        );
      case 'approvals':
        return (
          <div className="space-y-6 animate-in fade-in duration-300">
            {/* Action Approvals Card */}
            <div className="bg-white dark:bg-[#212121] border border-gray-100 dark:border-gray-800 rounded-2xl p-6 shadow-sm hover:border-gray-200 dark:hover:border-gray-700 transition-all">
                <div className="flex items-center gap-3 mb-2">
                    <div className="w-10 h-10 rounded-xl bg-gray-50 dark:bg-[#050505] border border-gray-100 dark:border-gray-800 flex items-center justify-center text-black dark:text-white shrink-0">
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
                            <path d="m9 11 2 2 4-4"></path>
                        </svg>
                    </div>
                    <div>
                        <h4 className="text-sm font-semibold text-black dark:text-white">Action Approvals</h4>
                        <p className="text-xs text-gray-500 dark:text-gray-400">Control when Neura requires your approval before executing actions.</p>
                    </div>
                </div>

                <div className="h-px bg-gray-55 dark:bg-gray-800/80 my-4 w-full" />
                
                <div className="space-y-3">
                    {/* Smart Auto-Approve Option */}
                    <button
                        onClick={async () => {
                            setApprovalMode('smart');
                            localStorage.setItem('setting_approval_mode', 'smart');
                            try {
                                await api.updateUser({ approval_mode: 'smart' });
                            } catch (e) {
                                console.error('Failed to save approval mode to database:', e);
                            }
                            showNotification('Switched to Smart Auto-Approve');
                        }}
                        className={`w-full text-left rounded-xl p-4 border transition-all duration-200 ${
                            approvalMode === 'smart'
                                ? 'border-black dark:border-white bg-gray-50/50 dark:bg-[#0a0a0a]/40 shadow-sm'
                                : 'border-gray-200/60 dark:border-gray-800/80 hover:border-gray-300 dark:hover:border-gray-750 bg-gray-50/10 dark:bg-[#050505]/10'
                        }`}
                    >
                        <div className="flex items-start justify-between gap-4">
                            <div className="flex items-start gap-3 flex-1 min-w-0">
                                <div className={`w-9 h-9 rounded-lg flex items-center justify-center shrink-0 mt-0.5 ${
                                    approvalMode === 'smart'
                                        ? 'bg-black dark:bg-white text-white dark:text-black'
                                        : 'bg-gray-100 dark:bg-gray-800 text-gray-500 dark:text-gray-400'
                                }`}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                        <path d="m12 3-1.912 5.813a2 2 0 0 1-1.275 1.275L3 12l5.813 1.912a2 2 0 0 1 1.275 1.275L12 21l1.912-5.813a2 2 0 0 1 1.275-1.275L21 12l-5.813-1.912a2 2 0 0 1-1.275-1.275L12 3Z" />
                                    </svg>
                                </div>
                                <div className="flex-1 min-w-0">
                                    <div className="flex items-center gap-2">
                                        <span className="text-sm font-semibold text-black dark:text-white">Smart Auto-Approve</span>
                                    </div>
                                    <p className="text-xs text-gray-500 dark:text-gray-400 mt-1 leading-relaxed">
                                        AI auto-runs safe actions like reading emails, listing events, and searching files. Sensitive actions always require your approval.
                                    </p>
                                    <div className="mt-3 flex flex-wrap gap-1.5">
                                        <span className="text-[10px] font-medium bg-gray-50 dark:bg-[#1a1a1a] text-gray-500 dark:text-gray-400 px-2 py-0.5 rounded-full border border-gray-250/60 dark:border-gray-800">Auto: Read & List</span>
                                        <span className="text-[10px] font-medium bg-gray-50 dark:bg-[#1a1a1a] text-gray-500 dark:text-gray-400 px-2 py-0.5 rounded-full border border-gray-250/60 dark:border-gray-800">Auto: Search & Fetch</span>
                                        <span className="text-[10px] font-semibold bg-black/5 dark:bg-white/10 text-black dark:text-white px-2 py-0.5 rounded-full border border-black/5 dark:border-white/10">Approve: Send & Create</span>
                                        <span className="text-[10px] font-semibold bg-black/5 dark:bg-white/10 text-black dark:text-white px-2 py-0.5 rounded-full border border-black/5 dark:border-white/10">Approve: Delete & Update</span>
                                    </div>
                                </div>
                            </div>
                            {/* Radio Circle */}
                            <div className="shrink-0 mt-1">
                                <div className={`w-4 h-4 rounded-full border flex items-center justify-center transition-all ${
                                    approvalMode === 'smart' 
                                        ? 'border-black dark:border-white' 
                                        : 'border-gray-300 dark:border-gray-700'
                                }`}>
                                    {approvalMode === 'smart' && (
                                        <div className="w-2 h-2 rounded-full bg-black dark:bg-white animate-in zoom-in-50 duration-200" />
                                    )}
                                </div>
                            </div>
                        </div>
                    </button>

                    {/* Manual Control Option */}
                    <button
                        onClick={async () => {
                            setApprovalMode('manual');
                            localStorage.setItem('setting_approval_mode', 'manual');
                            try {
                                await api.updateUser({ approval_mode: 'manual' });
                            } catch (e) {
                                console.error('Failed to save approval mode to database:', e);
                            }
                            showNotification('Switched to Manual Control — all actions need approval');
                        }}
                        className={`w-full text-left rounded-xl p-4 border transition-all duration-200 ${
                            approvalMode === 'manual'
                                ? 'border-black dark:border-white bg-gray-50/50 dark:bg-[#0a0a0a]/40 shadow-sm'
                                : 'border-gray-250/60 dark:border-gray-800/80 hover:border-gray-300 dark:hover:border-gray-750 bg-gray-50/10 dark:bg-[#050505]/10'
                        }`}
                    >
                        <div className="flex items-start justify-between gap-4">
                            <div className="flex items-start gap-3 flex-1 min-w-0">
                                <div className={`w-9 h-9 rounded-lg flex items-center justify-center shrink-0 mt-0.5 ${
                                    approvalMode === 'manual'
                                        ? 'bg-black dark:bg-white text-white dark:text-black'
                                        : 'bg-gray-100 dark:bg-gray-800 text-gray-500 dark:text-gray-400'
                                }`}>
                                    <Icons.ShieldAlert className="w-[18px] h-[18px]" />
                                </div>
                                <div className="flex-1 min-w-0">
                                    <div className="flex items-center gap-2">
                                        <span className="text-sm font-semibold text-black dark:text-white">Manual Control</span>
                                    </div>
                                    <p className="text-xs text-gray-500 dark:text-gray-400 mt-1 leading-relaxed">
                                        Every action requires your explicit approval before executing. Full control over what Neura does on your behalf.
                                    </p>
                                    <div className="mt-3 flex flex-wrap gap-1.5">
                                        <span className="text-[10px] font-semibold bg-black/5 dark:bg-white/10 text-black dark:text-white px-2 py-0.5 rounded-full border border-black/5 dark:border-white/10">Approve: All Actions</span>
                                    </div>
                                </div>
                            </div>
                            {/* Radio Circle */}
                            <div className="shrink-0 mt-1">
                                <div className={`w-4 h-4 rounded-full border flex items-center justify-center transition-all ${
                                    approvalMode === 'manual' 
                                        ? 'border-black dark:border-white' 
                                        : 'border-gray-300 dark:border-gray-700'
                                }`}>
                                    {approvalMode === 'manual' && (
                                        <div className="w-2 h-2 rounded-full bg-black dark:bg-white animate-in zoom-in-50 duration-200" />
                                    )}
                                </div>
                            </div>
                        </div>
                    </button>
                </div>
            </div>
          </div>
        );
      case 'notifications':
        return (
          <div className="space-y-6 animate-in fade-in duration-300">
            {/* Email Notifications Card */}
            <div className="bg-white dark:bg-[#212121] border border-gray-100 dark:border-gray-800 rounded-2xl p-6 shadow-sm hover:border-gray-200 dark:hover:border-gray-700 transition-all">
                <h4 className="text-xs font-semibold text-gray-400 dark:text-gray-500 uppercase tracking-wider mb-4">Email Notifications</h4>
                
                {/* Daily Email */}
                <div className="flex items-center justify-between py-3 border-b border-gray-50 dark:border-gray-800">
                    <div className="pr-4">
                        <span className="block text-sm font-medium text-black dark:text-white">Daily digest report</span>
                        <span className="text-xs text-gray-500 dark:text-gray-400">Get a daily morning email summary of your automations and usage.</span>
                    </div>
                    <ToggleSwitch 
                        checked={emailDaily} 
                        onChange={(val) => {
                            setEmailDaily(val);
                            localStorage.setItem('setting_email_daily', String(val));
                            showNotification(val ? "Daily email digests enabled" : "Daily email digests disabled");
                        }} 
                    />
                </div>

                {/* Weekly Email */}
                <div className="flex items-center justify-between py-3">
                    <div className="pr-4">
                        <span className="block text-sm font-medium text-black dark:text-white">Weekly newsletter & updates</span>
                        <span className="text-xs text-gray-500 dark:text-gray-400">Stay in the loop with new features, tips, and workflow ideas.</span>
                    </div>
                    <ToggleSwitch 
                        checked={emailWeekly} 
                        onChange={(val) => {
                            setEmailWeekly(val);
                            localStorage.setItem('setting_email_weekly', String(val));
                            showNotification(val ? "Weekly newsletter updates enabled" : "Weekly newsletter updates disabled");
                        }} 
                    />
                </div>
            </div>

            {/* Application Alerts Card */}
            <div className="bg-white dark:bg-[#212121] border border-gray-100 dark:border-gray-800 rounded-2xl p-6 shadow-sm hover:border-gray-200 dark:hover:border-gray-700 transition-all">
                <h4 className="text-xs font-semibold text-gray-400 dark:text-gray-500 uppercase tracking-wider mb-4">Application Alerts</h4>

                {/* Task completion alert */}
                <div className="flex items-center justify-between py-3 border-b border-gray-50 dark:border-gray-800">
                    <div className="pr-4">
                        <span className="block text-sm font-medium text-black dark:text-white">Task completion notifications</span>
                        <span className="text-xs text-gray-500 dark:text-gray-400">Alert me when a scheduled execution loops or completes.</span>
                    </div>
                    <ToggleSwitch 
                        checked={alertCompletion} 
                        onChange={(val) => {
                            setAlertCompletion(val);
                            localStorage.setItem('setting_alert_completion', String(val));
                            showNotification(val ? "Completion alerts enabled" : "Completion alerts disabled");
                        }} 
                    />
                </div>

                {/* Errors alert */}
                <div className="flex items-center justify-between py-3">
                    <div className="pr-4">
                        <span className="block text-sm font-medium text-black dark:text-white">Integration disconnects & credit warnings</span>
                        <span className="text-xs text-gray-500 dark:text-gray-400">High priority alert when API credentials expire or credits run low.</span>
                    </div>
                    <ToggleSwitch 
                        checked={alertErrors} 
                        onChange={(val) => {
                            setAlertErrors(val);
                            localStorage.setItem('setting_alert_errors', String(val));
                            showNotification(val ? "Error warnings enabled" : "Error warnings disabled");
                        }} 
                    />
                </div>
            </div>

            {/* System Banners Card */}
            <div className="bg-white dark:bg-[#212121] border border-gray-100 dark:border-gray-800 rounded-2xl p-6 shadow-sm hover:border-gray-200 dark:hover:border-gray-700 transition-all">
                <h4 className="text-xs font-semibold text-gray-400 dark:text-gray-500 uppercase tracking-wider mb-4">System Banners</h4>
                
                {/* Desktop Banner toggle */}
                <div className="flex items-center justify-between py-3">
                    <div className="pr-4">
                        <span className="block text-sm font-medium text-black dark:text-white">Show desktop banner notifications</span>
                        <span className="text-xs text-gray-500 dark:text-gray-400">Request permission to deliver system-level push popups.</span>
                    </div>
                    <ToggleSwitch 
                        checked={desktopBanner} 
                        onChange={(val) => {
                            setDesktopBanner(val);
                            localStorage.setItem('setting_desktop_banner', String(val));
                            showNotification(val ? "Desktop banner notifications enabled" : "Desktop banner notifications disabled");
                        }} 
                    />
                </div>

                <div className="mt-4">
                    <button
                        onClick={() => {
                            showNotification("🔔 Test notification triggered successfully!");
                        }}
                        className="px-5 py-2.5 bg-gray-50 dark:bg-[#050505] border border-gray-200 dark:border-gray-800 hover:border-black dark:hover:border-white rounded-xl text-xs font-medium text-black dark:text-white transition-colors"
                    >
                        Send Test Notification
                    </button>
                </div>
            </div>
          </div>
        );
      case 'subscription':
        return (
          <div className="space-y-6 animate-in fade-in duration-300">
              {/* Current Plan Card */}
              <div className="bg-white dark:bg-[#212121] text-black dark:text-white border border-gray-200 dark:border-gray-800 rounded-[24px] p-6 flex flex-col md:flex-row justify-between items-center gap-6 shadow-sm relative overflow-hidden">
                  <div className="absolute top-0 right-0 w-32 h-32 bg-gray-50 dark:bg-gray-800/20 rounded-full blur-xl pointer-events-none" />
                  <div className="relative z-10">
                      <div className="text-[10px] font-semibold text-gray-400 dark:text-gray-500 uppercase tracking-widest mb-1">Current Plan</div>
                      <div className="text-2xl font-semibold tracking-tight pb-1 inline-block capitalize">
                          {activePlan} Plan
                      </div>
                      <div className="text-xs mt-2.5 flex items-center gap-1.5 font-medium">
                          <Icons.Check className="w-3.5 h-3.5 text-green-500 shrink-0" />
                          {billingCycle && (
                             <span className="capitalize">{billingCycle} billing • </span>
                          )}
                          {expiresAt ? (
                             <span className="text-gray-400 dark:text-gray-500">
                               {new Date(expiresAt) < new Date() ? 'Expired on: ' : 'Plan expires: '}
                               {new Date(expiresAt).toLocaleDateString(undefined, { year: 'numeric', month: 'long', day: 'numeric' })}
                             </span>
                          ) : (
                             <span className="text-gray-400 dark:text-gray-500">Lifetime access</span>
                          )}
                      </div>
                  </div>
                  <div className="flex gap-2.5 shrink-0 w-full md:w-auto relative z-10">
                       <button 
                          onClick={handleInvoices}
                          className="flex-1 md:flex-none px-4 py-2 rounded-xl border border-gray-200 dark:border-gray-800 hover:border-black dark:hover:border-white transition-colors text-xs font-semibold text-black dark:text-white text-center bg-white dark:bg-[#050505] shadow-sm"
                       >
                            Invoices
                       </button>
                       <button 
                          onClick={handleManageBilling}
                          className="flex-1 md:flex-none px-5 py-2 rounded-xl bg-black dark:bg-white text-white dark:text-black hover:bg-black/90 dark:hover:bg-white/90 transition-all text-xs font-semibold shadow-sm text-center"
                       >
                            Change Plan
                       </button>
                  </div>
              </div>

              {/* Credits Usage Card */}
              <div className="border border-gray-100 dark:border-gray-800 rounded-[24px] p-6 space-y-4 bg-white dark:bg-[#212121] shadow-sm hover:border-gray-200 dark:hover:border-gray-700 transition-all">
                  <div className="flex justify-between items-end">
                      <div>
                          <span className="text-sm font-semibold text-black dark:text-white flex items-center gap-2">
                              <Icons.Coins className="w-4 h-4" /> Credits Usage
                          </span>
                          <span className="text-[11px] text-gray-500 dark:text-gray-400">Credits reset at the end of your billing cycle.</span>
                      </div>
                      <span className="text-xs font-semibold text-black dark:text-white">{usageStats.requests} / {usageStats.maxRequests} credits</span>
                  </div>
                  <div className="w-full bg-gray-50 dark:bg-gray-800 rounded-full h-2">
                      <div className="bg-black dark:bg-white h-2 rounded-full transition-all duration-500" style={{ width: `${Math.min(100, (usageStats.requests / usageStats.maxRequests) * 100)}%` }}></div>
                  </div>
              </div>

              {/* Connect Apps Summary Card */}
              <div className="border border-gray-100 dark:border-gray-800 rounded-[24px] p-6 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 bg-white dark:bg-[#212121] shadow-sm hover:border-gray-200 dark:hover:border-gray-700 transition-all">
                 <div className="pr-4">
                     <span className="block text-sm font-semibold text-black dark:text-white mb-1">Integrations & Connected Tools</span>
                     <p className="text-xs text-gray-500 dark:text-gray-400">Free accounts are limited to 3 active integrations. Pro & Premium tier accounts get unlimited app hook-ups.</p>
                     <div className="flex -space-x-1.5 mt-3">
                         {activeApps.length > 0 ? (
                             <>
                                 {activeApps.slice(0, 5).map((app, index) => {
                                     const AppIcon = getAppIcon(app.id);
                                     return (
                                         <div key={app.id} className="w-7 h-7 rounded-full bg-white dark:bg-[#050505] border border-gray-200 dark:border-gray-800 flex items-center justify-center relative shadow-sm p-1.5" style={{ zIndex: 30 - index }}>
                                             <AppIcon className="w-full h-full object-contain" />
                                         </div>
                                     );
                                 })}
                                 {activeApps.length > 5 && (
                                      <div className="w-7 h-7 rounded-full bg-white dark:bg-[#050505] border border-gray-200 dark:border-gray-800 flex items-center justify-center text-[10px] text-black dark:text-white font-semibold relative shadow-sm z-0">
                                         +{activeApps.length - 5}
                                      </div>
                                 )}
                             </>
                         ) : (
                              <span className="text-[11px] text-gray-450 italic">No apps connected yet.</span>
                         )}
                     </div>
                 </div>
                 <button
                     onClick={onManageIntegrations}
                     className="px-4 py-2 shrink-0 rounded-xl border border-gray-200 dark:border-gray-800 hover:border-black dark:hover:border-white hover:bg-black dark:hover:bg-white hover:text-white dark:hover:text-black transition-all text-xs font-semibold text-black dark:text-white bg-white dark:bg-[#050505]"
                 >
                     {activeApps.length > 0 ? 'Manage Apps' : 'Connect Apps'}
                 </button>
              </div>
          </div>
        );
      default:
        return null;
    }
  };

  const tabs = [
    { id: 'general', label: 'General', icon: Icons.Settings },
    { id: 'profile', label: 'Profile', icon: Icons.User },
    { id: 'security', label: 'Security', icon: (props: any) => (
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
        <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
        <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
      </svg>
    ) },
    { id: 'approvals', label: 'Action Approvals', icon: (props: any) => (
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
        <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
        <path d="m9 11 2 2 4-4"></path>
      </svg>
    ) },
    { id: 'notifications', label: 'Notifications', icon: Icons.Lightning },
    { id: 'subscription', label: 'Subscription', icon: Icons.CreditCard },
  ];

  return (
    <div className="w-full h-full flex flex-col bg-white dark:bg-[#050505] animate-in fade-in duration-300 relative">
      
      {/* Toast Notification */}
      {notification && (
        <div className="absolute top-4 left-1/2 transform -translate-x-1/2 z-50 bg-black text-white px-6 py-3 rounded-full shadow-xl animate-in fade-in slide-in-from-top-4 font-semibold text-xs tracking-wide">
            <span className="text-sm font-medium">{notification}</span>
        </div>
      )}

      {/* Main Header */}
      <div className="flex items-center justify-between px-10 py-8 border-b border-gray-100 dark:border-gray-800 flex-shrink-0 bg-white dark:bg-[#050505]">
        <h2 className="text-2xl font-normal text-gray-900 dark:text-white tracking-tight">Settings</h2>
        <div className="flex items-center gap-4">
          <button
            onClick={handleSignOut}
            className="flex items-center gap-2 px-4 py-2 border border-red-200 dark:border-red-900/50 hover:border-red-600 dark:hover:border-red-500 hover:bg-red-50/50 dark:hover:bg-red-950/30 rounded-xl text-xs font-semibold text-red-600 dark:text-red-400 transition-all shadow-sm"
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="shrink-0">
                <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
                <polyline points="16 17 21 12 16 7"></polyline>
                <line x1="21" y1="12" x2="9" y2="12"></line>
            </svg>
            Sign Out
          </button>
          <button
            onClick={onClose}
            className="p-2 text-gray-400 hover:text-gray-900 dark:hover:text-white hover:bg-gray-100 dark:hover:bg-gray-800 rounded-full transition-all"
          >
            <Icons.X className="w-6 h-6" />
          </button>
        </div>
      </div>

      {/* Horizontal Nav Bar */}
      <div className="flex-shrink-0 px-10 border-b border-gray-100 dark:border-gray-800 bg-white dark:bg-[#050505]">
        <div className="max-w-3xl mx-auto flex items-center gap-6 overflow-x-auto no-scrollbar">
          {tabs.map((tab) => {
            const isActive = activeTab === tab.id;
            return (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id as any)}
                className={`flex items-center gap-2 py-4 text-sm font-medium transition-all relative border-b-2 outline-none whitespace-nowrap ${
                  isActive
                    ? 'border-black dark:border-white text-black dark:text-white font-semibold'
                    : 'border-transparent text-gray-500 dark:text-gray-400 hover:text-black dark:hover:text-white'
                }`}
              >
                <tab.icon className="w-4 h-4 shrink-0" />
                <span>{tab.label}</span>
              </button>
            );
          })}
        </div>
      </div>

      {/* Content Body */}
      <div className="flex-1 overflow-y-auto p-10 no-scrollbar bg-white dark:bg-[#050505]">
        <div className="max-w-3xl mx-auto">
          {renderTabContent()}
        </div>
      </div>

    </div>
  );
};

export default SettingsPage;
